import {
	SportResolverService,
	GameService
} from "@prestosports/prestostats-core/Services";
import { EXPORT_STATS, GET_BOXSCORE } from "./constants";

export const exportStats = async (gameId, dispatch) => {
	const game = await GameService.getGame(gameId);
	const service = await SportResolverService.resolveStatsService(game.sportCode);
	const jsonStats = await service.getGameStatsFormatted(gameId);
	dispatch({
		type: EXPORT_STATS,
		payload: { jsonStats }
	});
};

export const getBoxScore = async (gameId, dispatch) => {
	const game = await GameService.getGame(gameId);
	const service = await SportResolverService.resolveStatsService(game.sportCode);
	const boxScore = await service.getBoxScore(gameId);
	dispatch({
		type: GET_BOXSCORE,
		payload: { boxScore }
	});
};
